import { BaseTheme, ThemeType } from '../types';

import { DefaultHeaderLogo } from './icons/default';
import { WorkFlowPlusHeaderLogo } from './icons/workflowPlus';
import { ContactPlusHeaderLogo } from './icons/contactPlus';
import { TumHeaderLogo } from './icons/tum';

const baseTheme: BaseTheme = {
  backgroundColor: '#233365',
  textColor: '#FFFFFF',
  textLinkColor: '#FFFFFF',
};

export const APSThemes: Array<ThemeType> = [
  {
    tenant: 'APS',
    product: 'default',
    baseTheme: baseTheme,
    productTheme: {
      headerLogo: <DefaultHeaderLogo />,
    },
  },
  {
    tenant: 'APS',
    product: 'workflowPlus',
    baseTheme: baseTheme,
    productTheme: {
      headerLogo: <WorkFlowPlusHeaderLogo />,
    },
  },
  {
    tenant: 'APS',
    product: 'contactPlus',
    baseTheme: baseTheme,
    productTheme: {
      headerLogo: <ContactPlusHeaderLogo />,
    },
  },
  {
    tenant: 'APS',
    product: 'apsApps',
    baseTheme: baseTheme,
    productTheme: {
      headerLogo: <DefaultHeaderLogo />,
    },
  },
  {
    tenant: 'APS',
    product: 'tum',
    baseTheme: baseTheme,
    productTheme: {
      headerLogo: <TumHeaderLogo />,
    },
  },
  {
    tenant: 'APS',
    product: 'apsServices',
    baseTheme: baseTheme,
    productTheme: {
      headerLogo: <DefaultHeaderLogo />,
    },
  },
];
